export async function initializeBootstrap() {
  await import('bootstrap/dist/js/bootstrap.bundle.min.js');
}

export async function initializeTooltips() {
  if (typeof window !== 'undefined') {
    const { Tooltip } = await import('bootstrap/dist/js/bootstrap.bundle.min.js');
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(
      (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
    );
  }
}

export function isDeviceBootstrapMd(): boolean {
  return typeof window !== 'undefined' && window.innerWidth > 767;
}

export function isDeviceBootstrapLg(): boolean {
  return typeof window !== 'undefined' && window.innerWidth > 991;
}
